import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Card, Spinner } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import Navbar from './Navbar';

const API_URL = process.env.REACT_APP_API_URL || "/";

const CargaMasivaDiagramas = () => {
  const [archivos, setArchivos] = useState([]);
  const [loading, setLoading] = useState(false);
  const usuario = JSON.parse(localStorage.getItem('user'))


  // 🧹 Limpiar archivos si cambia el usuario
  useEffect(() => {
    setArchivos([]);
  }, [usuario?.Legajo]);

  const handleArchivosChange = (e) => {
    const files = Array.from(e.target.files);
    const pdfs = files.filter(file => file.type === 'application/pdf');

    if (pdfs.length !== files.length) {
      toast.warning('⚠️ Algunos archivos fueron ignorados por no ser PDF');
    }

    setArchivos(pdfs);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (archivos.length === 0) {
      toast.error('Debes seleccionar al menos un archivo PDF');
      return;
    }

    const legajoActual = usuario?.Legajo?.toString();
    if (!legajoActual) {
      toast.error('No se detectó el legajo del usuario actual');
      return;
    }

    const formData = new FormData();
    archivos.forEach(file => formData.append('archivos', file));
    formData.append('subido_por', legajoActual);

    // console.log('📤 Subiendo como legajo:', legajoActual);

    setLoading(true);

    try {
      const res = await fetch(`${API_URL}/api/diagramas/carga-masiva`, {
        method: 'POST',
        body: formData
      });

      const data = await res.json();
      if (!data.success) throw new Error(data.error);

      const ignorados = data.ignorados || (archivos.length - data.registrados);
      toast.success(`✅ ¡Carga exitosa! Se registraron ${data.registrados} diagramas${ignorados > 0 ? `, ${ignorados} ignorados` : ''}`, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });

      setArchivos([]);
    } catch (err) {
      console.error('❌ Error en carga masiva:', err);
      toast.error('No se pudo completar la carga masiva');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Container className="py-4">
        <h4 className="mb-3">Carga Masiva de Diagramas</h4>
        <Card className="p-4">
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="archivos">
              <Form.Label>Seleccionar archivos PDF</Form.Label>
              <Form.Control
                type="file"
                accept=".pdf"
                multiple
                onChange={handleArchivosChange}
                disabled={loading}
                required
              />
              {archivos.length > 0 && !loading && (
                <ul className="mt-2 text-muted">
                  {archivos.map((file, idx) => (
                    <li key={idx}>{file.name}</li>
                  ))}
                </ul>
              )}
            </Form.Group>

            <Button variant="primary" type="submit" className="mt-4" disabled={loading}>
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Subiendo...
                </>
              ) : (
                'Subir Diagramas'
              )}
            </Button>
          </Form>
        </Card>
        <ToastContainer />
      </Container>
    </div>
  );
};

export default CargaMasivaDiagramas;